enum AutocompleteType {

  BDAY = 'bday',
  COUNTRY = 'country',
  COUNTRY_NAME = 'country-name',
  CURRENT_PASSWORD = 'current-password',
  EMAIL = 'email',
  IMPP = 'impp',
  LANGUAGE = 'language',
  NAME = 'name',
  NEW_PASSWORD = 'new-password',
  NONE = '',
  OFF = 'off',
  ON = 'on',
  ONE_TIME_CODE = 'one-time-code',
  ORGANIZATION = 'organization',
  ORGANIZATION_TITLE = 'organization-title',
  PHOTO = 'photo',
  POSTAL_CODE = 'postal-code',
  SEX = 'sex',
  STREET_ADDRESS = 'street-address',
  TEL = 'tel',
  TEL_EXTENSION = 'tel-extension',
  TRANSACTION_AMOUNT = 'transaction-amount',
  TRANSACTION_CURRENCY = 'transaction-currency',
  URL = 'url',
  USERNAME = 'username'

}

export default AutocompleteType;
